import { useState } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useGetOrganisations } from "@/features/organisations/api/get-organisations";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { RecordingViews } from "@/features/reporting/components/replay/recording-views";
import { ReplayBaseAnalytics } from "@/features/reporting/components/replay/replay-base-analytics";

export function ReplayReporting() {
  const { data: organisations } = useGetOrganisations();
  const [organisationId, setOrganisationId] =
    useState<string>("all-organisations");
  return (
    <section>
      <OnboardingHeader
        title="Replay Analytics"
        description="View analytics per organisation"
        className="mb-6"
        actions={
          <div>
            <Select
              value={organisationId}
              onValueChange={setOrganisationId}
              disabled={!organisations}
            >
              <SelectTrigger className="w-60 [&>span]:truncate">
                <SelectValue placeholder="All organisations" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all-organisations">
                  All organisations
                </SelectItem>
                {organisations?.map((organisation) => (
                  <SelectItem key={organisation.id} value={organisation.id}>
                    {organisation.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        }
      />
      <div className="space-y-6">
        <ReplayBaseAnalytics
          organisationId={
            organisationId === "all-organisations" ? undefined : organisationId
          }
        />
        <RecordingViews
          organisationId={
            organisationId === "all-organisations" ? undefined : organisationId
          }
        />
      </div>
    </section>
  );
}
